import Phaser from "phaser";
import ArcherCharacter from "../Character";
import { ILevelInputController } from "./ILevelInputController";

// X boundary — touches at or left of this are in the skill zone (buttons at x=60)
const BOW_ZONE_X = 150;

export default class MobileLevelInputController implements ILevelInputController {
  private mScene: Phaser.Scene;
  private mBowPointerId: number | null = null;
  private mOnPointerDown: (pointer: Phaser.Input.Pointer) => void;
  private mOnPointerUp: (pointer: Phaser.Input.Pointer) => void;

  constructor(scene: Phaser.Scene, character: ArcherCharacter) {
    this.mScene = scene;

    scene.input.addPointer(1); // ensure at least 2 active pointers

    this.mOnPointerDown = (pointer: Phaser.Input.Pointer) => {
      if (pointer.x <= BOW_ZONE_X) return; // skill zone — let buttons handle it
      if (this.mBowPointerId !== null) return; // bow already being pulled

      this.mBowPointerId = pointer.id;
      character.SetAimPointer(pointer);
      character.PullArrow();
    };

    this.mOnPointerUp = (pointer: Phaser.Input.Pointer) => {
      if (pointer.id !== this.mBowPointerId) return;
      this.mBowPointerId = null;
      character.ReleaseArrow();
    };

    scene.input.on("pointerdown", this.mOnPointerDown);
    scene.input.on("pointerup", this.mOnPointerUp);
  }

  public Destroy(): void {
    this.mScene.input.off("pointerdown", this.mOnPointerDown);
    this.mScene.input.off("pointerup", this.mOnPointerUp);
  }
}
